.general-error-page {
  height: 100vh;
  .blob {
    width: calc(100vw - 20%);
    max-width: calc(100vw - 35%);
    min-width: 900px;
    top: -58%;
    height: 100vh;
    min-height: 125vh;
    background: linear-gradient(
      135deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0) 30%,
      var(--color-primary-lighter-20) 100%
    );

    @media only screen and (max-width: 1024px) {
      min-width: 1200px;
      max-width: calc(100vw - 20%);
    }
    @media only screen and (max-width: 600px) {
      min-width: 900px;
      max-width: calc(100vw - 20%);
    }
  }
}
